import React, {useContext} from 'react';
import PuffLoader from 'react-spinners/PuffLoader';
import {css} from '@emotion/react';
import {CheckboxContext} from '../helpers/context';
import {toast} from 'react-toastify';

export default function SecondaryButton({
  buttonText,
  xPadding = 'px-5',
  yPadding = 'py-2',
  clearFilters,
  className = '',
  onClick,
  loading,
  fontSize = 'text-[13px]',
  src,
  alt,
  width,
  height,
  btnHeight = 'h-[34px]',
  appFilters,
  imgClass,
  leftImg,
  noOutline,
  color,
  loadColor = 'var(--color-primary)',
  ...props
}) {
  const override = css`
    border-color: #ffffff;
    position: absolute;
    background: transparent;
  `;

  const {setIsChecked} = useContext(CheckboxContext);

  const subDomainUser = localStorage.getItem('subdomain');
  const isProfiledRisk = subDomainUser?.includes('profiledrisk');

  const fontClass = isProfiledRisk ? 'font-sans' : '';

  const handleClearFilters = () => {
    if (Object.values(appFilters).filter(Boolean).length !== 0) {
      onClick && onClick();
      setIsChecked({});
      toast.success('Filters cleared');
    } else {
      onClick?.();
    }
  };

  return (
    <button
      type="button"
      disabled={props.disabled || loading}
      onClick={() => {
        clearFilters ? handleClearFilters() : onClick?.();
      }}
      className={` ${className} ${
        loading ? `flex items-center justify-center relative ${btnHeight}` : ''
      } ${btnHeight} ${fontSize} ${fontClass} font-normal duration-200 text-[#0D192C] transition flex items-center justify-center rounded-lg ${xPadding} ${yPadding}
    secondary_button`}
      {...props}
    >
      {loading ? <PuffLoader css={override} size={35} color="#ffffff" /> : null}

      {src && leftImg ? (
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={imgClass}
        />
      ) : null}

      {loading ? (
        <PuffLoader
          css={override}
          size={35}
          color={loadColor || color || '#ffffff'}
        />
      ) : null}
      <p className="">{buttonText}</p>
      {src && !leftImg ? (
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={imgClass}
        />
      ) : null}
    </button>
  );
}
